///// <reference types="@types/googlemaps" />
import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, SimpleChanges, OnChanges, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeIdentifier } from '@angular/compiler';
import { environment } from 'src/environments/environment';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { lastDateFunc, formatDate, formatDBTZDateToLocalDate } from 'lib/common/utils';
import { VquadbtfxoComponent } from 'src/app/statistics/network-status/vquadbtfxo/vquadbtfxo.component';
import { GooglemapstatuspopupComponent } from 'src/app/output-results/googlemapstatuspopup/googlemapstatuspopup.component';
import { AbsMapDisplayOptions } from 'src/app/shared/models/Configuration/GoogleMap/MapConfig';
import { AgmMap, MapsAPILoader, LatLngBounds } from '@agm/core';
import { GooglemaplegendpopupComponent } from 'src/app/output-results/googlemaplegendpopup/googlemaplegendpopup.component';
import { BasicComponent } from 'src/app/shared/basic/basic.component';
import { ResultsService } from 'src/app/shared/services/master/results/results.service';
import { Router, ActivatedRoute } from '@angular/router';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { Cluster } from 'cluster';
import { map } from 'rxjs/operators';
import { DemoService } from 'src/app/shared/demo.service';
import { Subscription } from 'rxjs';
import { DataFilter } from 'lib/ng-data-table/base';
import { debug } from 'util';
import { stream } from 'exceljs';
//import { OverlappingMarkerSpiderfier } from 'ts-overlapping-marker-spiderfier';
declare var google: any;
//https://stackoverflow.com/questions/42173662/typescript-error-cannot-find-name-google-in-ionic2-when-using-googlemaps-javas

//https://stackoverflow.com/questions/63349140/getting-error-while-build-angular-google-mapsagm - 1.1.0v

//https://github.com/DefinitelyTyped/DefinitelyTyped/issues/48574
//for agm/core - maps above this version is - imp


@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss', '../../graphics/analysis/analysis.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
  //encapsulation: ViewEncapsulation.None,
})
export class GoogleMapComponent implements OnInit, OnDestroy {
  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  hasFilters: boolean = false;

  rsltType: string = "GoogleMap";

  rsltTypeTS = '-1';
  TSSelected: number = 1;

  AutoRefreshInfo: any;
  isFilters: boolean = true;
  interval;

  title: string = "Google Maps";
  staticScreen = false; //true;
  @Output() childTitleEvent = new EventEmitter();

  isLoading = false;

  baseUrl: string;
  url: string;
  //lat = 42.536652;  //   lat: 37.422918, lng: -122.0854212
  //lng = -77.216;
  //a GPS Below Algeria(-13.410994,17.050781) as default center 
  lat = 40.4230;//12.9264;// india
  lng = -98.7372;//77.6012;//india

  ///for polygon
  polyLat: number;
  polyLng: number;
  lat1: number = 14.4673;
  lng1: number = 78.8242;
  lat2: number = 16.5062;
  lng2: number = 80.6480;
  //iurl: string = "https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|000000|FFFFFF|Bubb";
  iurl: string = "./assets/images/Marks/GreenMark.png";
  iurl_b: string = "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=|000000";
  // google maps zoom level
  zoom: number = 4;//4; 
  clulster_max_zoom = 12;
  minClusterSize = 5;

  usePredefinedConfig: string = "OFF";
  showAnalysis = true;
  showNetTest = true;
  showMobileInfo = true;
  showErrorEvents = true;
  showTypes = true;
  showResults = true;
  count: number = 0;
  infoWindowbody: any;
  previous: any;
  Loading: string;
  DrawRoute: string = "ON";
  DrawLine: string = "1";
  rsltTypeEach: any;
  bluetoothText: string;
  isBlutoothButton: boolean = false;
  mapRegionSelected: string = "0";
  btnRegioncolor: string = "btnToggle1";
  toggleMapRegion: boolean = false;
  infoRegionbody: any;
  analysisEnabled: string = "ON";
  netTestEnabled: string = "ON";
  mobileInfoEnabled: string = "ON";
  errorEventsEnabled: string = "ON";
  mapConfigID: number = 0;
  divPinLegends: any;
  showPopupLegend: boolean = false;
  currentPinLocation: any;

  thresholdLegends: string = "";
  thresholdLegendsCount: string = "";
  callIDLegends: string = "";//susheel
  devIDLegends: string = "";
  callEventsLegends: string = "";

  disableSection: string = "";
  showDrawRouteDirection: boolean = false;
  map: any;
  origin: any;
  destination: any;
  commonFilterDates: string;
  resultTypeID: string;
  leftPanel: boolean = false;
  limitPinCount: boolean = true;
  totalNetTestPassCount: number = 0;
  totalNetTestFailCount: number = 0;
  totalMobInfoPassCount: number = 0;
  totalMobInfoFailCount: number = 0;

  mapData = [];
  latlngValMainAgain = [];
  LatLongOriginal = [];
  mapFilterConfigList = [];
  infowindowArray = [];
  bluetoothData = [];
  mapRegionList = [];
  tempMarker = [];
  DisplayResultList1 = [];
  pinLegends = [];
  dynamicPinLegends = [];
  dynamicLegendPopupData = [];
  legendPopupData = [];
  appliedLegendThreshold = [];
  routeLatLng: any[] = [];
  PredefinedConfigOff = [];
  markerCollection: marker[];

  options = {
    suppressMarkers: true,
    polylineOptions: { strokeColor: 'red', strokeWeight: 2, strokeOpacity: 1.0, geodesic: true }
  };

  //// "../assets/images/Map/ClusterMarker_Circle.png"
  //,
  //hide: [
  //  {
  //    featureType: "poi",//poi.business
  //    stylers: [{ visibility: "off" }],
  //  },
  //  {
  //    featureType: "transit",
  //    elementType: "labels.icon",
  //    stylers: [{ visibility: "off" }],
  //  },
  //],

  mapOptions = {
    styles: [
      {
        url: "./assets/images/Map/ClusterMarker_Circle.png",
        width: 53,
        height: 53,
        textColor: '#fff',
      }
    ],
  };

  ///// to hide default googlemap pin marker like restaurant,pertol bunks etc. Transit is like public transport icon like train bus as of now it is visible 
  public customMapStyles = [
    {
      featureType: "poi",//poi.business
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "labels.icon",
      stylers: [{ visibility: "on" }],
    },
  ];

  pinMarker: marker;
  mapDisplayOptions = new AbsMapDisplayOptions();
  preDefinedConfigParam = new PredefinedConfig();
  //oms;//susheel

  dbTz = -500;
  dbAndBrHrs = -500;
  MainFilterID = 0;
  MainFilterTZ = 0;
  private subscriptions: Subscription[] = [];
  genArrDel = [];
  genArr = [];
  private dataFilter: DataFilter;
  filterEventIDSelected = false;
  delColSelected = false;
  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private http: HttpClient, private dialog: MatDialog, private sanitizer: DomSanitizer, private elRef: ElementRef, private mapsAPILoader: MapsAPILoader, private service: DemoService, private commonFilterService: CommonFilterService, private resultsService: ResultsService, private cd: ChangeDetectorRef) {
    this.baseUrl = environment.urlAddress + '/api/';
    this.dataFilter = new DataFilter();

    this.commonFilterService.TSType.subscribe(res => { this.TSSelected = res; });//TsType

    //this.commonFilterService.DB_TZ.subscribe(res => {
    //  this.dbTz = res;
    //});
    //if (this.dbTz == -500) {//query var col table
    //  this.service.getDBTimezoneDiff('VquadData').then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    this.dbTz = res;
    //  });
    //}
    this.commonFilterService.mainFilterID.subscribe(res => {
      this.MainFilterID = res;

      this.commonFilterService.mfTZ.subscribe(res => {
        this.MainFilterTZ = res;
      });
    });

    this.commonFilterService.setNonFiltersScreen(this.staticScreen);//false

    this.Loading = "";

    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;
      this.parentEvent();
    });

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {

      //// to set default value for all checkboxes of display option sections
      this.ResetDispalyOptionsList();
      //alert(1);
      if (res === 'onlyGMapInit' && !this.filterEventIDSelected) {
        if (this.usePredefinedConfig == "OFF")
          this.GetMapConfigData();
        else
          this.GetMapConfigByID(this.selMapConfig);
      }

      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {

        //console.log('refreshed')        
        //debugger;
        //alert(2);
        if (this.usePredefinedConfig == "OFF")
          this.GetMapConfigData();
        else
          this.GetMapConfigByID(this.selMapConfig);
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(res => {
      this.AllGeneralFilter = res;
      //alert(3);
      if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
        this.GetMapConfigData();

      //reset here
      if (this.delColSelected)
        this.delColSelected = false;
      if (this.clearAllFiltersBool)
        this.clearAllFiltersBool = false;

      this.delFilterColName = '';//reset if delete or clear all filters
    });
    this.subscriptions.push(_broadSubAllGeneralFilter);

    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        if (res !== '') {//IMP IMP
          //alert(4);
          this.delFilterColName = res;
          this.GetMapConfigData();
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      //console.log(res)     
      debugger;
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        //console.log('filtersWithEventID')
        this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //alert(5);
        if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0))
          this.GetMapConfigData();
      });
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //debugger;

        this.AutoRefreshInfo = res;

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            //alert(6);
            this.GetMapConfigData();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }

      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);

  }


  ngOnInit() {
    this.paths = [];
    this.GetAllMapRegion();
    this.GetPredefinedConfig();
    // this.GetMapConfigByID(42);
    // this.GetAllMapRegion();
    //this.DynamicHtmlEvent();
    //this.SetPinLegnd();

    //https://github.com/SebastianM/angular-google-maps/issues/1378
    this.cd.detectChanges();
  }

  ResetDispalyOptionsList() {
    this.DisplayResultList.forEach(item => item.Checked = true);
    this.AnalysisList.forEach(item => item.Checked = true);
    this.NetTestList.forEach(item => item.Checked = true);
    this.MobileInfoList.forEach(item => item.Checked = true);
    this.ErrorEventList.forEach(item => item.Checked = true);
    this.TypeList.forEach(item => item.Checked = false);
    this.ResultList.forEach(item => item.Checked = false);
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  LimitChangeEvent() {
    if (this.usePredefinedConfig == "OFF")
      this.GetMapConfigData();
    else
      this.GetMapConfigByID(this.selMapConfig);
  }

  clearAllFiltersBool = false;
  clearAllFilters() {
    this.delFilterColName = 'clearAllFilters';
    //this.hasFilters = false;
    this.GetMapConfigData();
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }

  ngOnDestroy() {
    // Clear out the old markers.
    this.markers = [];
    this.markerCollection = [];
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentEvent() {
    //debugger;
    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
  }

  status1: boolean = false;
  status2: boolean = false;
  togglePanes(type) {
    this.leftPanel = true;
    if (type == 1) {
      this.status1 = !this.status1;
      this.status2 = false;
    }
    else if (type == 2) {
      this.status2 = !this.status2;
      this.status1 = false;
    }
  }

  //legendList: any
  SetPinLegnd(legendList: any) {
    this.dynamicPinLegends = [];
    let legList = legendList.split('#');
    //console.log(legendList)
    for (let i = 1; i < legList.length; i++) {
      let item = legList[i].split('@');
      //console.log(item[5])
      this.dynamicPinLegends.push(
        {
          queryCount: item[0].split('-')[1],
          imgSrc: item[1].split('-')[1],
          resultType: item[2].split('-')[1],
          thresholdType: item[3].indexOf('- -') != -1 ? item[3].split('- -')[1].split(',')[0].trim() : item[3].split('-')[1].split(',')[0].trim(),//susheel - pass fail test-fail
          pinType: item[4].split('-')[1],
          //condVal: item[5].indexOf(' -') != -1 ? item[5].split('-')[1] + '-' + item[5].split('-')[2] : item[5].split('-')[1],//susheel - check if filter value is -ve
          condVal: item[5].replace(/::true/gi, '').replace(/::false/gi, '').replace(/condVal-/gi, ''),//susheel
          noOfRows: item[6].split('-')[1]
        }
      );
    }
    //console.log(this.dynamicPinLegends)

    //this.dynamicPinLegends = [
    //  {
    //    queryCount:'100',
    //    imgSrc:'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin||00FF00|FFFFFF',
    //    resultType: 'LegAll',
    //    thresholdType : 'PASS',
    //    pinType: 'Threshold Type',
    //    condVal: 'Battery Level() >= 90 < font style = color: green > AND < /font></br > RSSI(dBm) <= 100',
    //    noOfRows:'0'
    //  }
    //];
  }


  DynamicHtmlEvent() {
    //var body = "<img (click)="ShowMapLegendWin(0); " src="https://chart.googleapis.com/chart?chst=d_map_xpin_letter&amp;chld=pin||00FF00|FFFFFF" height="27px">";
    //this.test = this.sanitizer.bypassSecurityTrustHtml(body);
  }

  ngAfterViewInit() {
    //debugger;

    //var el = document.getElementById("img12");
    //el.onclick = this.ShowMapLegendWin;

    //this.elRef.nativeElement.querySelector('img').addEventListner('click', this.ShowMapLegendWin.bind(this));
    //this.elRef.nativeElement.querySelector('button').addEventListner('click', this.ShowMapLegendWin.bind(this));
    // setTimeout(() => { this.map.triggerResize(); }, 500)

  }

  ///private event: MouseEvent;

  // initial center position for the map///////////////////////////////// start Pin Marker
  clickedMarker(infowindow, index: number) {
    debugger;
    this.resultTypeID = "";
    this.isLoading = true;
    try {
      //this.resultTypeID = this.infowindowArray[index].split('@')[0];
      //this.previous = null;
      //console.log(this.previous)

      ///// close previous window
      //index = index + 1;  ///elumalai
      if (this.previous) {
        //console.log(this.previous["isOpen"])
        if (this.previous["isOpen"] == true)
          this.previous.close();
      }
      this.previous = infowindow;

      //console.log(index);//susheel
      //if (index != 11) {
      if (this.bluetoothData[index].indexOf('IGNORETS-VQUAD') > -1) {
        //console.log(this.bluetoothData[index])//susheel
        this.bluetoothText = this.bluetoothData[index].split('$')[1];//this.bluetoothData[index].split('(')[2].split(')')[0];
        this.isBlutoothButton = true;
      }
      else
        this.isBlutoothButton = false;

      let latlng = {
        lat: infowindow.hostMarker.latitude,
        lng: infowindow.hostMarker.longitude
      }

      this.resultTypeID = this.infowindowArray[index].split('@')[0];

      this.geocode(latlng).then(place => {
        this.currentPinLocation = place.formatted_address;
        let pinInfo = this.infowindowArray[index].split('@')[1].replace('Loading...', this.currentPinLocation)
        this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml(pinInfo);
        this.previous.open();
        this.previous["isOpen"] = true;//susheel

        this.isLoading = false;

      })
        .catch(err => {
          console.log(err);
        });

      //}
      //else {

      //  this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml("fsf");
      //}
      //console.log(this.infowindowArray[index]);
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  //mapClicked($event: MouseEvent) {
  //  alert();
  //}


  // //markerDragEnd(m: marker, $event: MouseEvent) 
  markerDragEnd() {
    //alert(1);
    console.log('dragEnd');
  }

  markers: marker[] = [
    {
      lat: this.lat.toString(),
      lng: this.lng.toString(),
      //lat: this.lat,
      //lng: this.lng,
      label: '', //'A',
      draggable: true,
      iconurl: '',// this.iurl,
      widthImg: 0,
      heightImg: 0,
      resultType: '',
      popUpRsltType: '',
      itemID: ''
    },

  ]


  ///////to get address based on lat n lng
  geocode(latlng: any): Promise<any> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode(
        {
          'location': latlng
        },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            resolve(results[0]);
          } else {
            reject(new Error(status));
          }
        }
      );
    });
  }


  //*********** Marker Cluster
  zoomChanged(event: any) {
     
    try {
      this.zoom = event;
      //alert('zoom');

      //this.isLoading = true;
      debugger;
      if (this.markers.length > 0) {
        this.markerCollection = this.markers;
        this.markers = [];
      }
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  OnTilesLoaded() {
    try {
      this.isLoading = false;
      debugger;
      if (this.markers.length <= 0)
        this.markers = this.markerCollection;
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  dragEndMap() {
    //console.log(event);
    debugger;
    try {
      //if (!this.leftPanel) {

       
      //  this.isLoading = true;


      //  setTimeout(() => { this.isLoading = false; }, 15000);
      //}
      //else
      //  this.leftPanel = false;
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  onBoundChanged() {
    //console.log(event);
    debugger;
    try {
      //this.isLoading = true;
      //debugger;
      //if (this.markers != undefined && this.markers.length > 0) {
      //  this.markerCollection = this.markers;
      //  this.markers = [];
      //}
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  CalCluster() {
    //console.log(this.markers);
  }
  //***********


  /////////////////////////////////// End Pin Marker

  /////////////// start Polygon

  paths = [
    [
      { lat: this.lat, lng: this.lng },
      { lat: this.lat, lng: this.lng + 0.1 },
      { lat: this.lat + 0.1, lng: this.lng + 0.1 },
      { lat: this.lat + 0.1, lng: this.lng },
      { lat: this.lat, lng: this.lng },
    ], [
      { lat: this.lat1, lng: this.lng1 },
      { lat: this.lat1, lng: this.lng1 + 0.1 },
      { lat: this.lat1 + 0.1, lng: this.lng1 + 0.1 },
      { lat: this.lat1 + 0.1, lng: this.lng1 },
      { lat: this.lat1, lng: this.lng1 },
    ], [
      { lat: this.lat2, lng: this.lng2 },
      { lat: this.lat2, lng: this.lng2 + 0.1 },
      { lat: this.lat2 + 0.1, lng: this.lng2 + 0.1 },
      { lat: this.lat2 + 0.1, lng: this.lng2 },
      { lat: this.lat2, lng: this.lng2 },
    ]
  ];

  ToggleMapRegion() {
    if (!this.toggleMapRegion) {
      this.btnRegioncolor = "btnToggle2";
      this.tempMarker = this.markers;
      this.markers = [];
    }
    else {
      this.btnRegioncolor = "btnToggle1";
      this.markers = this.tempMarker;
      this.tempMarker = [];
    }
    this.toggleMapRegion = !this.toggleMapRegion;

  }

  onMouseOver($event, infoWindow, path) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infoWindow;
    // alert($event.latLng.lat());
    //console.log($event.coords.lat)//-susheel
    this.polyLat = $event.coords.lat;
    this.polyLng = $event.coords.lng;
    this.infoRegionbody = path.label;
    infoWindow.open();
  }

  onMouseOut($event, infoWindow) {
    //infoWindow.close();
  }

  GetAllMapRegion() {

    this.url = this.baseUrl + 'GoogleMaps/GetMapRegion';

    this.GetMapConfigData_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];

      this.mapRegionList = rows;
      //this.GetMapConfigData();
    });
  }

  GetMapRegionDetail(criteriaName) {

    if (criteriaName == "0") {
      this.paths = [];
    }

    this.url = this.baseUrl + 'GoogleMaps/GetMapRegion?criteriaName=' + criteriaName;

    this.GetMapConfigData_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];

      this.BindMapRegion(rows);
    });
  }

  BindMapRegion(mapRegion) {
    //debugger;
    this.paths = [];
    if (mapRegion.length > 0) {
      // if ($(hiddenArrayRegs[ha] + txtId).val().length > 0) {//hidden field of dataquery.aspx page
      var province = ";";
      for (let h = 0; h < mapRegion.split('()').length - 1; h++) {
        var splitEachReg = ((mapRegion.split('()'))[h].split('~'))[0].split(';');
        var chosenColorLoad = "#" + ((mapRegion.split('()'))[h].split('~'))[1];
        var polyLabel = ((mapRegion.split('()'))[h].split('~'))[2];
        var regionArr = [];
        for (let i = 0; i <= splitEachReg.length - 2; i++) {

          if ((splitEachReg[i].split('^'))[1] != 3) {//place, Degrees or co-ordinates
            var Lat = parseFloat(((splitEachReg[i].split('^'))[0].split(','))[0]);
            var Lng = parseFloat(((splitEachReg[i].split('^'))[0].split(','))[1]);

            //var latLng = new google.maps.LatLng(Lat, Lng);//parseFloat(
            regionArr.push({ lat: Lat, lng: Lng, label: polyLabel, polyColor: chosenColorLoad });

          }
          else {//Province
            province += ((splitEachReg[i].split('^'))[0].split(','))[1] + "@" + polyLabel + "@" + chosenColorLoad + ";";
          }
        }
        this.paths.push(regionArr);
        //if (regionArr.length > 0) {
        //  if (splitEachReg.length >= 4) {
        //    var flightPath = makePolygon(regionArr, chosenColorLoad, polyLabel);
        //    arrPolys.push(flightPath);
        //  }
        //  else
        //    drawCircle(regionArr, map, chosenColorLoad, polyLabel);
        //}
      }
      // }
    }
  }

  /////////////// end Polygon

  /// start Toggle Div
  DivToggle(controlName) {

    switch (controlName) {
      case 'showAnalysis':
        this.showAnalysis = !this.showAnalysis;
        break;
      case 'showNetTest':
        this.showNetTest = !this.showNetTest;
        break;
      case 'showMobileInfo':
        this.showMobileInfo = !this.showMobileInfo;
        break;
      case 'showErrorEvents':
        this.showErrorEvents = !this.showErrorEvents;
        break;
      case 'showTypes':
        this.showTypes = !this.showTypes;
        break;
      case 'showResults':
        this.showResults = !this.showResults;
        break;
    }

  }
  /// end toggle div

  //////////////////// start Check ALL / UnCheck ALL
  CheckBox(event) {
    const checked = event.target.checked;
    //this.nontrade.forEach(item => item.selected = checked);
  }

  GetMapChanges(controlName = '') {//shoukd be similar to below GetMapConfigByID function
    this.isLoading = true;
    if (controlName != '')
      this.DivToggle(controlName);

    this.GetDispaylOption();
    ////
    this.preDefinedConfigParam = new PredefinedConfig();
    this.preDefinedConfigParam.strStartDate = this.commonFilterDates.split('^')[0];
    this.preDefinedConfigParam.strEndDate = this.commonFilterDates.split('^')[1];
    this.preDefinedConfigParam.strLastRecord = '';
    this.preDefinedConfigParam.TimeStamp_Type = this.TSSelected.toString();
    //console.log(this.TSSelected)
    this.preDefinedConfigParam.FilterOnOff = 1;
    this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;

    this.url = this.baseUrl + 'GoogleMaps/GetMapOnChangeEvent';

    this.preDefinedConfigParam.generalFilter = this.genArr;

    this.GetMapDispayOptions_Service().subscribe((res: any) => {
      let rows: any[] = JSON.parse(res) as any[];
      ////console.log(rows)
      //if (rows != null)
      //  this.BindMapDetails(rows);
      debugger;
      if (rows != null) {
        if (rows.length > 1) {

          if (this.usePredefinedConfig == 'ON')
            this.SetPinLegnd(rows[rows.length - 2]);

          //// legend popup data
          this.dynamicLegendPopupData = [];
          this.dynamicLegendPopupData.push(JSON.parse(rows[rows.length - 1]));
          //console.log(this.dynamicLegendPopupData);
          //this.legendPopupData = this.dynamicLegendPopupData;

          if (this.usePredefinedConfig == "ON") {
            rows.pop();
            rows.pop();
          }

          this.BindMapDetails(rows);////elumalai


          //this.BindMapDetails(rows);//susheel
        }
      }
      else {
        this.markers = [];
        this.markerCollection = [];
      }

      this.isLoading = false;
    });
  }

  GetDispaylOption() {

    this.mapDisplayOptions.mapConfigID = this.mapConfigID;
    this.mapDisplayOptions.usePredefinedConfig = this.usePredefinedConfig == "OFF" ? 0 : 1;
    this.mapDisplayOptions.analysisEnabled = this.analysisEnabled;
    this.mapDisplayOptions.netTestEnabled = this.netTestEnabled;
    this.mapDisplayOptions.mobileInfoEnabled = this.mobileInfoEnabled;
    this.mapDisplayOptions.errorEventsEnabled = this.errorEventsEnabled;
    this.mapDisplayOptions.DisplayResultList = this.DisplayResultList;//DisplayResultList
    this.mapDisplayOptions.AnalysisList = this.AnalysisList;
    this.mapDisplayOptions.NetTestList = this.NetTestList;
    this.mapDisplayOptions.MobileInfoList = this.MobileInfoList;
    this.mapDisplayOptions.ErrorEventList = this.ErrorEventList;
    this.mapDisplayOptions.TypeList = this.TypeList;
    this.mapDisplayOptions.ResultList = this.ResultList;
  }

  //////////////////// end Check ALL / UnCheck ALL

  ////////////////// start Get PageLoad Data
  test: string;
  selMapConfig: string;
  GetPredefinedConfig(prevConfigID?) {
    //alert();
    if (this.previous) {
      //console.log(this.previous["isOpen"])
      if (this.previous["isOpen"] == true)
        this.previous["isOpen"] = false;
    }

    this.commonFilterService.setUsePredefinedConfigData(this.usePredefinedConfig);

    if (this.usePredefinedConfig == "ON") {
      this.url = this.baseUrl + 'GoogleMaps/GetMapFilter';

      this.GetMapConfigData_Service().subscribe((res: any) => {
        let rows: any[] = JSON.parse(res) as any[];
        //console.log(rows)

        //debugger;
        this.mapFilterConfigList = rows;
        if (rows.length > 0)//susheel
        {
          //console.log(prevConfigID)
          if (!prevConfigID)
            this.selMapConfig = rows[0].ID;
          this.GetMapConfigByID(this.selMapConfig);
        }

        this.GetAllMapRegion();
      });
    }
    else {
      this.GetMapConfigData();
    }
  }

  AllGeneralFilter = [];
  filtersWithEventID = {};
  filters = {};
  delFilterColName = '';
  async GetMapConfigData() {


    this.Loading = "Loading ..."
    this.isLoading = true;

    //console.log(this.delFilterColName)
    if (this.delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key.toUpperCase() !== this.SetTimestampSearch(this.TSSelected).toUpperCase())
          delete this.filters[key];
      }
    }

    if (this.delFilterColName != 'clearAllFilters') {
      this.genArr = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"].toUpperCase() != this.SetTimestampSearch(this.TSSelected).toUpperCase();
      });

      this.commonFilterService.GeneralFilterDF.subscribe(res => {
        //console.log(res)
        this.filters = res;
      });
    }

    if (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0) {
      this.dataFilter.filters = this.filtersWithEventID;
      //console.log(filtersWithEventID)
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });
      let generalFilterArrayAll = this.dataFilter.getProcessedFiltersArray("ALL");
      this.genArr = [...this.genArr, ...generalFilterArrayAll];

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
      let generalFilterArrayNew = this.dataFilter.getProcessedFilters("");
      this.filters = { ...this.filters, ...generalFilterArrayNew };
    }
    //console.log(genArr)
    //console.log(filters)

    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      //cleared = 1;
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });

      for (const key in this.filters) {
        if (key == this.delFilterColName)
          delete this.filters[key];
      }
    }
    //console.log(this.genArr)
    this.hasFilters = this.genArr.length <= 0 ? false : true;

    if (this.delFilterColName != 'clearAllFilters') {
      //let newFilters = {};
      //for (const key in this.filters) {
      //  if (this.filters[key].rsltType == 'call-events' || this.filters[key].rsltType == '') {
      //    let value = this.filters[key].value;
      //    let matchMode = this.filters[key].matchMode;
      //    let valueTo = this.filters[key].valueTo;
      //    let type = this.filters[key].type;
      //    let rsltType = this.filters[key].rsltType;
      //    let title = this.filters[key].title;
      //    newFilters[key] = { value, matchMode, valueTo, type, rsltType, title };
      //  }
      //}
      ////console.log(newFilters)
      this.commonFilterService.setGeneralFilterData(this.filters);//(newFilters);
    }
    else
      this.hasFilters = false;
    debugger;

    //if (this.MainFilterID != 0) {
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      this.dbAndBrHrs = res;
    });
    if (this.dbAndBrHrs == -500) {//query var col table
      await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
        this.commonFilterService.setDBAndBrowserHrsDiff(res);
        this.dbAndBrHrs = res;
        this.commonFilterDates = formatDate(new Date(Date.now() + -1 * 600 * 1000), this.dbTz, this.dbAndBrHrs) + "^" + formatDate(new Date(), this.dbTz, this.dbAndBrHrs);//"06/02/2019 11:00:00^06/02/2019 20:00:00";
      });
    }
      //}

    this.url = this.baseUrl + 'GoogleMaps/GetMapConfigData';

    ////// Common filter dates  
    //let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";  
    this.commonFilterService.TSBetween.subscribe(res => this.commonFilterDates = res);//latest dates selected is set here from service
    //Added to set proper dates here based on range selection
    this.commonFilterService.TSRangeFilter.subscribe(res => {
      if (res.RangeType !== "custom") { this.commonFilterDates = lastDateFunc(res.RangeType, this.dbTz, this.dbAndBrHrs) }
    });//sets start and end dates to latest timestamps based on range type selection - IMP

    this.commonFilterService.setDatesProperties(this.commonFilterDates);


    //// common filter date range
    //let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";  
    //this.commonFilterService.TSBetween.subscribe(res => dates = res);//latest dates selected is set here from service
    ////Added to set proper dates here based on range selection
    //this.commonFilterService.TSRangeFilter.subscribe(res => { if (res.RangeType !== "custom") { dates = lastDateFunc(res.RangeType) } });//sets start and end dates to latest timestamps based on range type selection - IMP
    //this.PredefinedConfigOff.push({
    debugger;
    this.preDefinedConfigParam = new PredefinedConfig();
    this.preDefinedConfigParam.limitPinCount = this.limitPinCount;
    this.preDefinedConfigParam.strStartDate = this.commonFilterDates.split('^')[0];
    this.preDefinedConfigParam.strEndDate = this.commonFilterDates.split('^')[1];
    this.preDefinedConfigParam.strLastRecord = '';

    this.preDefinedConfigParam.TimeStamp_Type = this.TSSelected.toString();

    this.preDefinedConfigParam.FilterOnOff = 1;
    this.preDefinedConfigParam.MainFilterID = this.MainFilterID;
    if (this.preDefinedConfigParam.MainFilterID > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;
    // //});

    if (this.genArr.length > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;

    this.preDefinedConfigParam.generalFilter = this.genArr;

    this.GetMapConfigData_Service().subscribe((res: any) => {
      //console.log(res);// - susheel
      let rows: any[] = JSON.parse(res) as any[];
      //let data = rows;
      debugger;
      //if (this.usePredefinedConfig == "OFF") {
      //  if (rows != null) {
      //    if (rows.length > 0) {
      //      this.pinLegends = rows[rows.length - 1].replace('[', '').replace(']', '').split(',');
      //      rows.pop();
      //    }
      //  }
      //}
      //else {
      //  //this.divPinLegends = this.sanitizer.bypassSecurityTrustHtml(rows[rows.length - 1]);
      //  //rows.pop();
      //}

      //this.bluetoothData = rows;
      //console.log(rows);// - susheel
      //debugger;
      if (rows != null) {

        this.BindMapDetails(rows);

      }
      else {
        this.markers = [];
        this.markerCollection = [];
      }
      this.Loading = "";

      this.isLoading = false;
      //let str = "1,2,3"; 
      //console.log(str.split(","));
      //this.cd.detectChanges();
    });
    //setTimeout(() => { this.map.triggerResize(); }, 500)
    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (this.delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });
      //console.log(this.genArrDel)
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
  }

  async updateMarkers(newBounds: LatLngBounds) {
    //debugger;

    //this.cd.detectChanges();

    //this.markers = [];
    //setTimeout(() => {
    //  //this.markers = this.markerCollection.filter(marker => newBounds.contains(new google.maps.LatLng(marker.lat, marker.lng)));
    //}, 1000);

    // setTimeout(() => { this.map.triggerResize(); }, 500)
  }



  BindMapDetails(mapData) {
    this.mapData = mapData;
    this.markers = [];
    this.markerCollection = [];
    //debugger;
    if (this.usePredefinedConfig == "OFF") {
      if (this.mapData != null) {
        if (this.mapData.length > 0) {
          this.pinLegends = this.mapData[this.mapData.length - 1].replace('[', '').replace(']', '').split(',');
          ///// for total nettest and Mobile info count
          if (this.pinLegends.length > 0) {
            debugger;
            this.totalNetTestPassCount = parseInt(this.pinLegends[26]) + parseInt(this.pinLegends[28]) + parseInt(this.pinLegends[30]) + parseInt(this.pinLegends[32]) + parseInt(this.pinLegends[34]) + parseInt(this.pinLegends[36]) + parseInt(this.pinLegends[38]) + parseInt(this.pinLegends[40]) + parseInt(this.pinLegends[42]);
            this.totalNetTestFailCount = parseInt(this.pinLegends[29]) + parseInt(this.pinLegends[31]) + parseInt(this.pinLegends[33]) + parseInt(this.pinLegends[35]) + parseInt(this.pinLegends[37]) + parseInt(this.pinLegends[39]) + parseInt(this.pinLegends[41]) + parseInt(this.pinLegends[43]);
            this.totalMobInfoPassCount = parseInt(this.pinLegends[45]) + parseInt(this.pinLegends[47]) + parseInt(this.pinLegends[49]);
            this.totalMobInfoFailCount = parseInt(this.pinLegends[46]) + parseInt(this.pinLegends[48]) + parseInt(this.pinLegends[50]);

          }
          this.mapData.pop();
        }
      }
    }

    this.bluetoothData = this.mapData;

    //if (this.usePredefinedConfig == "ON")
    // this.mapData.pop();

    if (this.mapData != null) {
      this.Initialize(this.mapData, "VQuad ", 1);
    }

    //console.log(this.markers);

    //for (let i = 0; i < this.mapData.length; i++) {
    //  var data = this.mapData[i].MERGED.split(",");
    //this.pinMarker = new marker();GetMapRegion
    //this.pinMarker.lat = data[0];
    //this.pinMarker.lng = data[1];
    //this.pinMarker.label = "Z" + i;
    //this.pinMarker.iconurl = this.iurl_b;

    //this.markers.push(this.pinMarker);
    //}
  }

  ////////////////  end Get pageload data

  ///////////////////////////////// start get map config byID

  GetMapConfigByID(mapConfigID, mapLegendApplied = 0) {

    if (this.previous) {
      //console.log(this.previous["isOpen"])
      if (this.previous["isOpen"] == true)
        this.previous["isOpen"] = false;
    }

    this.Loading = "Loading ...";
    this.isLoading = true;

    this.mapConfigID = mapConfigID;
    this.GetDispaylOption();

    let dRoute = this.DrawRoute == "ON" ? 1 : 0;

    this.preDefinedConfigParam = new PredefinedConfig();
    this.preDefinedConfigParam.limitPinCount = this.limitPinCount;
    this.preDefinedConfigParam.strStartDate = this.commonFilterDates.split('^')[0];
    this.preDefinedConfigParam.strEndDate = this.commonFilterDates.split('^')[1];
    this.preDefinedConfigParam.strLastRecord = '';

    this.preDefinedConfigParam.TimeStamp_Type = this.TSSelected.toString();

    this.preDefinedConfigParam.FilterOnOff = 1;
    this.preDefinedConfigParam.gMapConfigID = mapConfigID;
    this.preDefinedConfigParam.drawRoute = dRoute;
    this.preDefinedConfigParam.MainFilterID = this.MainFilterID;
    if (this.preDefinedConfigParam.MainFilterID > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;
    //debugger;
    this.url = this.baseUrl + 'GoogleMaps/GetMapConfigDataByID';
    if (mapLegendApplied == 1) {
      this.preDefinedConfigParam.thresholdLegends = this.thresholdLegends;
      this.preDefinedConfigParam.thresholdLegendsCount = this.thresholdLegendsCount;
      this.preDefinedConfigParam.callIDLegends = this.callIDLegends;//susheel
      this.preDefinedConfigParam.devIDLegends = this.devIDLegends;
      this.preDefinedConfigParam.callEventsLegends = this.callEventsLegends;

    }

    this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;

    this.preDefinedConfigParam.generalFilter = this.genArr;

    this.GetMapConfigDataByID_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      //console.log(rows);

      //debugger;
      this.infowindowArray = [];
      //this.divPinLegends = this.sanitizer.bypassSecurityTrustHtml(rows[rows.length - 1]);
      if (rows != null) {
        if (rows.length > 1) {
          if (this.usePredefinedConfig == 'ON')
            this.SetPinLegnd(rows[rows.length - 2]);
          debugger;
          //// legend popup data
          this.dynamicLegendPopupData = [];
          this.dynamicLegendPopupData.push(JSON.parse(rows[rows.length - 1]));
          //console.log(this.dynamicLegendPopupData);
          //this.legendPopupData = this.dynamicLegendPopupData;
          debugger;
          rows.pop();
          rows.pop();
          this.BindMapDetails(rows);//susheel
        }
      }
      else {
        this.markers = [];
        this.markerCollection = [];
      }
      this.Loading = "";
      this.isLoading = false;
    });
  }
  //////////////////////////////// end get map config byID


  /////////////////////////// Start Initialize Map From old webviewer function
  Initialize(latlngValMain, timestampTypeMain, outputGPS) {//provides array of locations
    //debugger;
    this.cd.detectChanges();
    this.latlngValMainAgain = latlngValMain;
    this.infowindowArray = [];

    var arrPolys = 0;///selectedRegConfigApply(1, map);//Draw polygons commented by elumalai
    ////ZOOM LIMIT
    ////Changes zoom levels when the projection is available.
    //google.maps.event.addListenerOnce(map, "projection_changed", function () {
    //  map.setMapTypeId(google.maps.MapTypeId.HYBRID);  //Changes the MapTypeId in short time.
    //  setZoomLimit(map, google.maps.MapTypeId.ROADMAP);
    //  setZoomLimit(map, google.maps.MapTypeId.HYBRID);
    //  setZoomLimit(map, google.maps.MapTypeId.SATELLITE);
    //  setZoomLimit(map, google.maps.MapTypeId.TERRAIN);
    //  map.setMapTypeId(google.maps.MapTypeId.ROADMAP);  //Sets the MapTypeId to original.
    //});


    /////////Get zoom and position
    //google.maps.event.addListener(map, "bounds_changed", function () {
    //  document.getElementById("boundHid").value = latlngZoomCenter;
    //  document.getElementById("zoomHid").value = map.getZoom();
    //  var bounds = map.getBounds();

    //});


    ////////Set marker position to center when Zoom changed
    //google.maps.event.addListener(map, "zoom_changed", function () {
    //  map.setCenter(latlngZoomCenter);
    //  if (map.getZoom() == 3)
    //    map.setCenter(new google.maps.LatLng(40.4230, -98.7372));
    //});

    //codeLatLng('N39º08\'36\'\' W077º12\'57\'\'');
    //let rsltTypeEach = new Array();
    this.rsltTypeEach = new Array();
    //debugger
    //console.log(latlngValMain)
    var loopcnt = 0
    var loopInterval = 1000;
    this.count = 0;
    //console.log(latlngValMain.length);
    //console.log(latlngValMain);

    for (var varLatLong = 0; varLatLong < latlngValMain.length; varLatLong++)//add marker for each location
    {
      loopcnt = varLatLong;
      //if (latlngValMain.length > 1000 && loopcnt == loopInterval) {
      //  setTimeout(() => {
      //    //// delay map binding by 5 secs for large data
      //  }, 15000);
      //  loopInterval = loopInterval + 1000;
      //}

      this.pinMarker = new marker();
      if (latlngValMain[varLatLong] != null) {
        if (latlngValMain[varLatLong].length > 0) {
          //console.log(latlngValMain[varLatLong])
          var latlngValMainSplit = latlngValMain[varLatLong].split("^");// split to seperate orig value - Co-or^Rslt^Device ID#DateTime^(imgPath#Thresh-Params/VQLoc/VQPhID/CallEvents-COND button)^Threshold Type^RSLT btn
          //console.log(latlngValMainSplit)// - susheel
          if (latlngValMainSplit[0].length > 0)//check for NULL latlong
          {

            var typeNameMain = latlngValMainSplit[1].indexOf('_') != -1 ? (latlngValMainSplit[1].split('_'))[0] : latlngValMainSplit[1];//Type of result
            var typeName = latlngValMainSplit[1].indexOf('_') != -1 ? (latlngValMainSplit[1].split('_'))[0] : latlngValMainSplit[1];//Type of result
            if (typeName == 'VQUAD')
              typeName = 'CALL EVENTS';
            else if (typeName == 'TDM')
              typeName = 'Audio and Delay';
            else if (typeName.indexOf('GENERAL') != -1)
              typeName = typeName.replace('GENERAL', 'PHONEINFO');
            else if (typeName.indexOf('VQT') != -1)
              typeName = typeName.replace('VQT', 'PESQ');
            else if (typeName.indexOf('VQUADAPP') != -1)
              typeName = 'VQUAD NODE';
            else if (typeName.indexOf('MOBILEAPP') != -1)
              typeName = 'MOBILE';

            this.rsltTypeEach[this.count] = latlngValMainSplit[1].indexOf('_') != -1 ? (latlngValMainSplit[1].split('_'))[1] : latlngValMainSplit[1];//add results into results array

            var TSPhID = "";
            if (latlngValMainSplit.length > 2)
              TSPhID = latlngValMainSplit[2];//Device ID#Timestamp

            var pinImgSrc = "";
            if (latlngValMainSplit.length > 3)
              pinImgSrc = (latlngValMainSplit[3].split("@"))[0];//imgSrcMain+Param + (@COND btn - not required)
            //alert(pinImgSrc);   
            var rsltBtn = "";
            var rsltHead = "";
            var rsltVals = "";
            var ThresholdType = "";

            if (latlngValMainSplit.length == 5)//RSLT btn for other than Threshold(because no Pass/Fail val in split) 
            {
              rsltVals = (latlngValMainSplit[4].split('@'))[1];
              rsltHead = (latlngValMainSplit[4].split('@'))[0];
            }
            else if (latlngValMainSplit.length == 6)//RSLT btn for Threshold   
            {
              if (latlngValMainSplit[4].indexOf("PASS") != -1)
                ThresholdType = "PASS";
              else if (latlngValMainSplit[4].indexOf("FAILED") != -1)
                ThresholdType = "TEST FAILED";
              else if (latlngValMainSplit[4].indexOf("FAIL") != -1)
                ThresholdType = "FAIL";
              typeName = typeName + latlngValMainSplit[4];// add pass / fail to rsltType  
              rsltVals = (latlngValMainSplit[5].split('@'))[1];
              rsltHead = (latlngValMainSplit[5].split('@'))[0];
            }
            //rsltVals = rsltVals.replace(/\'/g,"&#39;");   
            //rsltVals = rsltVals.replace(/º/g,"&#176;");
            if (latlngValMainSplit.length > 4) {
              rsltVals = rsltVals.replace(/\s/g, "&nbsp;");
              rsltBtn = rsltHead + "@" + rsltVals + '\"); class=popupButton>Result Display</button></p>';
            }

            //rsltBtn = rsltBtn.replace(/\'/g,"&#39;");   
            //rsltBtn = rsltBtn.replace(/º/g,"&#176;");
            //alert(rsltBtn);
            var startLatLang = "0,0,";
            var endLatLang = latlngValMainSplit[0];

            //French
            if (endLatLang.split(",").length > 3) {
              var arrGPS = endLatLang.split(",");
              endLatLang = "";
              for (var x = 0; x < arrGPS.length; x++) {
                var delim = ",";
                if (x % 2 == 0 && x < 3)
                  delim = ".";
                endLatLang += arrGPS[x] + delim;
              }
              if (endLatLang != "")
                endLatLang = endLatLang.substring(0, endLatLang.length - 1);
            }

            var routeColor;
            if (latlngValMainSplit[0].indexOf("@") != -1) {//start information
              startLatLang = (latlngValMainSplit[0].split("@"))[1].trim();
              endLatLang = (latlngValMainSplit[0].split("@"))[0];
              routeColor = (latlngValMainSplit[0].split("@"))[2].trim();
            }
            //debugger;
            /////// to get result id from each array item to pass in popup model


            if (this.usePredefinedConfig == "ON") {
              //console.log(rsltVals.split('!')[0]);
              rsltVals = rsltVals != "" ? rsltVals.split('!')[0] : latlngValMain[varLatLong].split('$')[1]; //rsltVals.split('!')[0];
            }
            else
              rsltVals = latlngValMain[varLatLong].split('$')[1];
            //debugger;
            this.CodeLatLng(endLatLang, typeNameMain, this.count, endLatLang, TSPhID, pinImgSrc, rsltBtn, ThresholdType, startLatLang, routeColor, arrPolys, timestampTypeMain, outputGPS, rsltVals);//end GPS location, result-type, coutVal, again end GPS, PhID+TS, ImgPath+Params+COND btn, RSLT btn, start GPS
            this.count++;
          }
        }
      }

      //if (varLatLong == latlngValMain.length - 1) {

      //  //alert(latlngValMain.length);
      //  ///lat = 12.9264;// 42.536652;//39.143 ///12.9264;
      //  ///lng = 77.6012;//
      //  const bounds: LatLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(startLatLang, endLatLang));
      //  this.updateMarkers(bounds);
      //}
    }
    //console.log(this.markers)// - susheel
    //this.cd.detectChanges();

  }
  //else {
  //  __doPostBack("btnRefresh", "OnClick");
  //}
  // end of initialize function

  CodeLatLng(latlngVal, rsltType, myCount, LatLongOrig1, TimeStamp, NewImgSrc, FinalRsltBtn, ThresholdType, startLatLang, routeColor, arrPolys, timestampTypeMain, outputGPS, rsltVals) {

    //loc, result type, count val, GPS Co-orditanes, PhID+TS, Image path+Params+COND btn, RSLT btn, start GPS
    //console.log(latlngVal + "," + rsltType + "," + myCount + "," + LatLongOrig1 + "," + TimeStamp + "," + NewImgSrc + "," + FinalRsltBtn + "," + ThresholdType + "," + startLatLang);

    //if (ThresholdType != "") // susheel
    //debugger

    var input = latlngVal;
    var NewTS = TimeStamp.split('#'); //Split Phone ID and TS
    NewImgSrc = NewImgSrc.replace('Call Control Event</font>', 'Call Control Event&nbsp;</font>')
    var extrSpacesThreshold = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
    if (NewTS[2] == "DUMMY")
      extrSpacesThreshold = "&nbsp;"
    if (ThresholdType.length > 0)
      ThresholdType = "<div><font face='verdana' style='color:blue'>THRESHOLD</font> " + extrSpacesThreshold + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + ThresholdType + "</div>";

    if (input.length > 0) {
      var latlngStr = input.split(',', 3); //GPS co-or
      var latConvert = latlngStr[0].length > 0 ? latlngStr[0] : "0";
      var lngConvert = latlngStr[1].length > 0 ? latlngStr[1] : "0";
      var displayEndGPS = latlngStr[2];

      var startlatlngStr = startLatLang.split(',', 3); //start GPS co-or
      var startlatConvert = startlatlngStr[0].length > 0 ? startlatlngStr[0] : "0";
      var startlngConvert = startlatlngStr[1].length > 0 ? startlatlngStr[1] : "0";

      if (latConvert == "0" && lngConvert == "0")//check for 0 latlong
      {
        this.count--;
        return;
      }


      var splitNewImg = NewImgSrc.split("#"); //Pin img path + Params + COND btn
      if (displayEndGPS == "NONE")
        displayEndGPS = LatLongOrig1.replace(',NONE', '');
      var latDecimalSpaces = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";//20
      var lngDecimalSpaces = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";//16
      if (outputGPS == 0) {
        var newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + displayEndGPS + "</div>"; //End GPS Loc
        if ((startlatConvert + "," + startlngConvert) != "0,0" && startlatlngStr[2] != displayEndGPS)
          newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "Device GPS (Start)</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + startlatlngStr[2] + "</div>" + newLatLongOrig1.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'Device GPS (End)</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'); //Start and End GPS Loc
        if (NewImgSrc.length > 0)//new info added
          newLatLongOrig1 = splitNewImg[1] + newLatLongOrig1; //(Params + COND btn) + GPS Loc + RSLT btn
        this.LatLongOriginal[this.count] = newLatLongOrig1; //GPS InfoBubble
      }
      else {
        var newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "Latitude</font> " + latDecimalSpaces + " " + latConvert + "</div>"; //End GPS Lat
        newLatLongOrig1 += "<div><font face='verdana' style='color:blue'>" + "Longitude</font> " + lngDecimalSpaces + " " + lngConvert + "</div>"; //End GPS Long
        if ((startlatConvert + "," + startlngConvert) != "0,0" && startlatlngStr[2] != displayEndGPS)
          newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "Device Latitude (Start)</font> " + latDecimalSpaces + " " + startlatConvert + "</div>"
            + "<div><font face='verdana' style='color:blue'>" + "Device Longitude (Start)</font> " + lngDecimalSpaces + " " + startlngConvert + "</div>"
            + newLatLongOrig1.replace('Latitude</font> ' + latDecimalSpaces, 'Device Latitude (End)</font> ' + latDecimalSpaces).replace('Longitude</font> ' + lngDecimalSpaces, 'Device Longitude (End)</font> ' + lngDecimalSpaces); //Start and End GPS Loc
        if (NewImgSrc.length > 0)//new info added
          newLatLongOrig1 = splitNewImg[1] + newLatLongOrig1; //(Params + COND btn) + GPS Loc + RSLT btn
        this.LatLongOriginal[this.count] = newLatLongOrig1; //GPS InfoBubble
      }
      //debugger;
      var lat = parseFloat(latConvert);
      var lng = parseFloat(lngConvert);
      var ImgRslt = "Yellow";
      var rsltTypePopUp = "pesq";
      var timestampNameRsltType = timestampTypeMain;//"VQuad ";
      if (rsltType == "VQT" || rsltType == "POLQA") {
        ImgRslt = "Yellow";
        if (rsltType == "POLQA")
          rsltTypePopUp = "polqa";
      }
      else {
        if (timestampNameRsltType == "VQT ")
          timestampNameRsltType = "VQuad ";

        rsltTypePopUp = rsltType.toLowerCase();
        if (rsltType.indexOf("VQUAD") != -1 || rsltType.indexOf("TDM") != -1 || rsltType.indexOf("RTD") != -1 || rsltType.indexOf("SNR") != -1 || rsltType.indexOf("OWD") != -1 || rsltType.indexOf("PDD") != -1) {
          ImgRslt = "Green";
          rsltTypePopUp = "audio-delay";
          if (rsltType.indexOf("VQUAD") != -1)
            rsltTypePopUp = "call-events";
        }
        else if (rsltType == "VBA")
          ImgRslt = "Pink";
        else if (rsltType == "EMU")
          ImgRslt = "Orange";
        //else if (rsltType == "POLQA")
        //    ImgRslt = "Red";
        else if (rsltType.indexOf("FAX") != -1)
          ImgRslt = "Black";
        else if (rsltType.indexOf("VAC") != -1) {
          ImgRslt = "Purple";
          timestampNameRsltType = "Device ";
        }
        else if (rsltType == "CONNDROP") {
          ImgRslt = "Red";
          timestampNameRsltType = "Device ";
        }
        else if (rsltType.indexOf("GENERAL") != -1 || rsltType.indexOf("SIM") != -1 || rsltType.indexOf("UE") != -1) {
          ImgRslt = "GreenNew";
          timestampNameRsltType = "Device ";
          rsltTypePopUp = "mobileinfo-" + rsltType;
        }
        else//NetTest
        {
          ImgRslt = "Blue";
          timestampNameRsltType = "Device ";
          rsltTypePopUp = "nettest-" + rsltType;
        }
      }

      if (rsltType.indexOf("-FAIL") != -1)
        ImgRslt = "Red";

      var image = './assets/images/Marks/' + ImgRslt + 'Mark.png';

      if (rsltType.indexOf("-ERROR") != -1 && rsltType.indexOf("FAX") != -1) {
        image = 'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|E|000000|FFFFFF';
        rsltTypePopUp = "fax";
      }
      else if (rsltType.indexOf("-ERROR") != -1 && (rsltType.indexOf("VQUAD") != -1 || rsltType.indexOf("RTD") != -1 || rsltType.indexOf("SNR") != -1 || rsltType.indexOf("OWD") != -1 || rsltType.indexOf("PDD") != -1)) {
        image = 'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|E|009900|000000';
        rsltTypePopUp = "audio-delay";
        if (rsltType.indexOf("VQUAD") != -1)
          rsltTypePopUp = "call-events";
      }
      else if (rsltType.indexOf("-FAIL") != -1) {
        image = 'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|F|BC1E1E|000000';
        if (rsltType.indexOf("VAC") != -1)
          rsltTypePopUp = "vac";
        else if (rsltType.indexOf("GENERAL") != -1 || rsltType.indexOf("SIM") != -1 || rsltType.indexOf("UE") != -1)
          rsltTypePopUp = "mobileinfo-" + (rsltType.split('-'))[0];
        else
          rsltTypePopUp = "nettest-" + (rsltType.split('-'))[0];
      }

      //for image size vary dynamically based on pin / bubble
      var widthImg = 24;
      var heightImg = 30;

      //for mobile and vquad status
      if (rsltType.indexOf("MOBILEAPP") != -1) {
        image = './assets/images/Marks/Apps/' + (rsltType.split("-"))[1] + '.png';
        rsltTypePopUp = "mobileapp";
      }
      else if (rsltType.indexOf("VQUADAPP") != -1) {
        widthImg = 40;
        heightImg = 25;
        image = './assets/images/Marks/Apps/' + (rsltType.split("-"))[1] + '.png';
        rsltTypePopUp = "vquadapp";
      }
      if (NewImgSrc.length > 0)//new image
        image = splitNewImg[0];

      /////// start new code elumalai bind lat lng to marker array
      //this.pinMarker = new marker();
      this.pinMarker.lat = lat.toString();
      this.pinMarker.lng = lng.toString();
      this.pinMarker.label = "";//(rsltType.split("-"))[1];
      this.pinMarker.iconurl = image; //this.iurl_b;
      this.pinMarker.widthImg = widthImg;//susheel
      this.pinMarker.heightImg = heightImg;
      this.pinMarker.resultType = rsltType.replace("GENERAL", "PHONEINFO");//susheel
      this.pinMarker.popUpRsltType = rsltTypePopUp;
      this.pinMarker.itemID = rsltVals;

      this.markers.push(this.pinMarker); ///commented by elumalai for performance purpose

      //this.markerCollection.push(this.pinMarker);  //elumalai for boundchange event 



      var lat_lng_mine = new Array();
      //https://roufid.com/angular-uncaught-referenceerror-google-not-defined/ - refer to region config component getloc 
      //https://www.digitalocean.com/community/tutorials/angular-angular-google-maps
      //https://stackoverflow.com/questions/47198904/angular-google-is-not-defined
      this.mapsAPILoader.load().then(() => {// - susheel

        var latlngNewMain = new google.maps.LatLng(lat, lng);

        //// commented by elumalai
        var startlatlngNewMain = new google.maps.LatLng(parseFloat(startlatConvert), parseFloat(startlngConvert));
        lat_lng_mine.push(startlatlngNewMain);//start
        lat_lng_mine.push(latlngNewMain);//end

        if ((startlatConvert + "," + startlngConvert) != "0,0" && (latConvert + "," + lngConvert) != "0,0" && (startlatlngStr[2] != displayEndGPS))
          this.routeLatLng.push({ origin: startlatlngNewMain, destination: latlngNewMain, color: routeColor });// to draw followpath route by elumalai


        //this.cd.detectChanges();
      });

      var resu = "Loading...";
      var finalResu = resu;
      //map.setZoom(myZoom);

      //set and open windows
      var TSandPhID = "";
      if (TimeStamp.length > 0) {
        var phoneIDHead = "VQuad Device ID&nbsp;";
        var locHead = "VQuad Call ID&nbsp;&nbsp;";
        var extrSpaceVQuadTS = "";
        var infoWindowWidth = 300;
        var VQuadNodeSpaces = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        var VQuadNodeGPSSpaces = this.LatLongOriginal[myCount];
        var phoneIDValue = NewTS[0];
        var locValue = NewTS[1];
        if (NewTS[2].indexOf('IGNORETS') != 0) {
          if (timestampNameRsltType == "Device ") {
            extrSpaceVQuadTS = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
            infoWindowWidth = 400;
            phoneIDHead += extrSpaceVQuadTS.replace(extrSpaceVQuadTS, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
            locHead += extrSpaceVQuadTS.replace(extrSpaceVQuadTS, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
            TSandPhID = "<div><font face='verdana' style='color:blue'>" + timestampNameRsltType + "Timestamp (Start)</font> &nbsp;" + NewTS[2] + "</div>";
            TSandPhID += "<div><font face='verdana' style='color:blue'>" + timestampNameRsltType + "Timestamp (End)</font> &nbsp;&nbsp;&nbsp;&nbsp;" + NewTS[3] + "</div>";
            if (VQuadNodeGPSSpaces !== undefined) {
              VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('PARAMETERS</font> &nbsp;', 'PARAMETERS</font> ' + extrSpaceVQuadTS);
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'VQuad GPS</font> ' + extrSpaceVQuadTS + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Latitude</font> ' + extrSpaceVQuadTS + latDecimalSpaces);
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Longitude</font> ' + extrSpaceVQuadTS + lngDecimalSpaces);
              }
            }
          }
          else {
            var endTS = NewTS[2];
            if (NewTS[2] == "DUMMY")
              endTS = NewTS[3];
            extrSpaceVQuadTS = "&nbsp;";
            TSandPhID = "<div><font face='verdana' style='color:blue'>" + timestampNameRsltType + "Timestamp</font> &nbsp;" + endTS + "</div>";
            if (VQuadNodeGPSSpaces !== undefined) {
              VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('PARAMETERS</font> &nbsp;', 'PARAMETERS</font> ' + extrSpaceVQuadTS);
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'VQuad GPS</font> ' + extrSpaceVQuadTS + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Latitude</font> ' + extrSpaceVQuadTS + latDecimalSpaces);
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Longitude</font> ' + extrSpaceVQuadTS + lngDecimalSpaces);
              }
            }
          }
          TSandPhID += ThresholdType;
          phoneIDValue = "&nbsp;" + phoneIDValue;
        }
        else if (NewTS[2].indexOf('IGNORETS') == 0)//VQuad Or Mobile App
        {
          FinalRsltBtn = (NewTS[2].split("-"))[2];
          if (NewTS[2].indexOf('-VQUAD') != -1)//VQUAD
          {
            phoneIDHead = "IP Address";
            locHead = "Node Name";
            phoneIDValue = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + phoneIDValue;
            //locValue = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + locValue;
            VQuadNodeSpaces = "";
            finalResu = resu.replace(/<br\/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/g, '<br/>');//have to be done only once
            if (VQuadNodeGPSSpaces !== undefined) {
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'VQuad GPS</font> ');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Latitude &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> ');
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Longitude &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> ');
              }
            }
          }
          else//MOBILE
          {
            locValue = (locValue.split("-"))[1];
            phoneIDHead = "Device PhoneID&nbsp;&nbsp;&nbsp;";
            locHead = "Device Name&nbsp;";
            locValue = "&nbsp;&nbsp;" + locValue;
            if (VQuadNodeGPSSpaces !== undefined) {
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'Device GPS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> ');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Device Latitude' + '&nbsp;&nbsp;&nbsp;&nbsp;' + '</font> ');
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Device Longitude' + '&nbsp;&nbsp;' + '</font> ');
              }
            }
          }
        }
        if (NewTS[0] != "IGNOREDEVICE")
          TSandPhID += "<div><font face='verdana' style='color:blue'>" + phoneIDHead + "</font> &nbsp;" + phoneIDValue + "</div>";
        if (NewTS[1] != "IGNORELOCATION")
          TSandPhID += "<div><font face='verdana' style='color:blue'>" + locHead + "</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + locValue + "</div>";

        if (NewTS[4] != undefined && NewTS[4].indexOf('Result Display') != -1)
          FinalRsltBtn = NewTS[4];
      }

      var substrResu = finalResu.substring(0, finalResu.indexOf("<br/>&nbsp;"));
      var chkWidthResu = infoWindowWidth;
      if (substrResu.length > 30)
        chkWidthResu = infoWindowWidth + (substrResu.length - 30) * 10;
      this.infowindowArray.push(rsltVals + "@<div style='width: " + chkWidthResu + "px; overflow: hidden;'><div><font face='verdana' style='color:blue'>RESULT</font> " + extrSpaceVQuadTS + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + VQuadNodeSpaces + this.rsltTypeEach[myCount].replace('TDM', 'Audio and Delay') + "</div>" + TSandPhID + VQuadNodeGPSSpaces + "<div><font face='verdana' style='color:blue'>LOCATION</font> " + extrSpaceVQuadTS + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + VQuadNodeSpaces + finalResu + "</div>" + "</div>");

      //console.log(rsltType + rsltVals);
      //console.log("modified");
      //console.log(rsltTypePopUp);
      //console.log("**********");

      //this.pinMarker.itemID = rsltVals;
      //this.markers.push(this.pinMarker); ///commented by elumalai for performance purpose
      // this.markerCollection.push(this.pinMarker);  //elumalai for boundchange event

    } //end return 

    ////// commeneted by elumalai drawroute
    if ((startlatConvert + "," + startlngConvert) != "0,0" && (latConvert + "," + lngConvert) != "0,0" && (startlatlngStr[2] != displayEndGPS))
      this.DrawMapRoute(lat_lng_mine, routeColor);

    //this.cd.detectChanges();
  }// end of codelatlng function N12º55'35'' E77º36'04''

  /////////////////////////// End Initialize Map From old webviewer function

  /////////////////////////// Start Draw Route
  onMapReady(map: any) {
    //console.log(map);

    //const bounds: LatLngBounds = new google.maps.LatLngBounds();
    //for (const mm of this.markers) {
    //  bounds.extend(new google.maps.LatLng(mm.lat, mm.lng));
    //}
    //map.fitBounds(bounds);



    //const bounds: LatLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(this.lat, this.lng));
    // this.updateMarkers(bounds);
    //// dragend  idle
    //map.addListener("idle", this.updateMarkers(bounds));
    //this.map.addListener("idle", function () {
    //  //do what you want

    //});



    this.map = map;
    //this.DrawMapRoute();
  }

  DrawMapRoute(lat_lng, routeColor) {
    // DrawMapRoute() {
    //debugger;
    if (this.DrawRoute == "OFF")
      return;

    //var lineSymbol = {
    //  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    //};

    if (this.DrawLine == "1") { ///Draw short parabola route or Plane/sea routes

      //const flightPlanCoordinates = [
      //  { lat: this.lat1, lng: this.lng1 },
      //  //  { lat: this.lat1, lng: this.lng1},
      //  { lat: this.lat2, lng: this.lng2 },
      //];

      const line = new google.maps.Polyline({
        strokeOpacity: 0.5,
        path: lat_lng,  //[],
        map: this.map
      });

    }
    else {// //Draw road route in actual way google mentioned road ways
      if (this.routeLatLng.length > 0)
        this.showDrawRouteDirection = true
    }


  }

  //////////////////////////  End Draw Route

  /////////////////////////// start Popup Section bluetooth and status display
  //VQuad node Bluetooth List  
  OpenBTFXODialog() {

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    //debugger;


    dailogConfig.data = { pageValue: this.bluetoothText, nodeStatus: true };

    this.dialog.open(VquadbtfxoComponent, dailogConfig);
  }

  //VQuad or Mobile Nodes N/W status
  OpenStatusDialog(itemID, resultType) {
    /// alert(resultType);
    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;

    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "70%";
    //debugger;

    let vquadID = "";
    //itemID = "21";
    //resultType = "call-events";

    if (this.usePredefinedConfig == "OFF")
      vquadID = itemID + "@true" + "$" + this.usePredefinedConfig; // for testing itemid =21
    else
      vquadID = itemID + "@" + resultType + "$" + this.usePredefinedConfig; // for testing itemid =37014543 and resultype="call-events"

    dailogConfig.data = { pageValue: vquadID };

    let dialogRef = this.dialog.open(GooglemapstatuspopupComponent, dailogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        //debugger;
        this.commonFilterService.setNonFiltersScreen(this.staticScreen);
      }
    );
  }

  //Results window
  OpenBasicDialog(requestID, rsltType) {
    //debugger;
    //if (this.resultTypeID != "")
    // requestID = this.resultTypeID;

    //console.log(requestID + ',' + rsltType)
    const dailogConfig = new MatDialogConfig();
    //dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    let newRsltType = rsltType;
    let selectedSubResults = "";
    if (rsltType.indexOf("mobileinfo") != -1 || rsltType.indexOf("nettest") != -1) {
      newRsltType = (rsltType.split('-'))[0];

      selectedSubResults = (rsltType.split('-'))[1];

      //got from sub-results-selection component
      let netTestData = [
        { id: 1, name: 'TCP' },
        { id: 2, name: 'UDP' },
        { id: 3, name: 'VOIP' },
        { id: 4, name: 'ROUTE' },
        { id: 5, name: 'HTTP' },
        { id: 6, name: 'FTP' },
        { id: 7, name: 'DNS' },
        { id: 8, name: 'SMS' },
        { id: 9, name: 'EMAIL' }
      ];
      let mobileInfoData = [
        { id: 1, name: 'GENERAL' },
        { id: 2, name: 'SIM' },
        { id: 3, name: 'UE' }
      ];
      let rsltIndex = -1;
      if (newRsltType == "nettest")
        rsltIndex = netTestData.find(x => x.name == selectedSubResults).id;
      else
        rsltIndex = mobileInfoData.find(x => x.name == selectedSubResults).id;
      this.resultsService.setNetTestOrMobInfoByID(rsltIndex);

      selectedSubResults += newRsltType == "nettest" ? "DATA" : "INFO";
    }

    dailogConfig.data = { popupOrNot: true, requestID: requestID, rsltType: newRsltType, TSSelected: this.TSSelected };

    //https://stackoverflow.com/questions/41357021/passing-input-values-to-dialog-component
    let dialogRef = this.dialog.open(BasicComponent, dailogConfig);
    let instance = dialogRef.componentInstance;
    instance.selectedSubResults = selectedSubResults;

    //dialogRef.afterClosed().subscribe(
    //  data => { this.successMsgBasic = data; }
    //);
  }

  ShowMapLegendWin(rsltType, condVal, pinType) {

    if (rsltType.trim() == "Audio and Delay")
      rsltType = "TDM";

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "50%";
    //debugger;
    this.legendPopupData = this.dynamicLegendPopupData;
    //console.log(this.legendPopupData[0])
    this.legendPopupData = this.legendPopupData[0].filter(m => m.ConditionValue.replace(/::true/gi, '').replace(/::false/gi, '') == condVal && m.RsltType == rsltType);

    let currPinRsltIndx = this.legendPopupData[0].RsltIndex; //-1;
    //let currListEachRsltCondVal = "";
    //this.dynamicLegendPopupData[0].every(item => {
    //  if (currListEachRsltCondVal != item.ConditionValue) {
    //    currListEachRsltCondVal = item.ConditionValue;
    //    currPinRsltIndx++;

    //    if (currListEachRsltCondVal == this.legendPopupData[0].ConditionValue)
    //      return false; 
    //  }
    //  return true;
    //});
    //console.log(currListEachRsltCondVal)

    if (this.legendPopupData.length <= 0) {
      return;
    }
    else {
      /// mark threshold.isapplied =1  if already applied
      for (let i = 0; i < this.appliedLegendThreshold.length; i++) {
        if (this.appliedLegendThreshold[i].replace(/::true/gi, '').replace(/::false/gi, '') == condVal) {
          //debugger
          this.legendPopupData[0].IsApplied = 1;//as fetched from orig list, set isApplied again everytime
          this.appliedLegendThreshold.splice(i);//if already applied remove and add freshly condVal below again everytime
        }
      }
    }
    //console.log(this.legendPopupData)

    dailogConfig.data = { pageValue: this.legendPopupData, pinType: pinType };

    let dialogResult = this.dialog.open(GooglemaplegendpopupComponent, dailogConfig);

    dialogResult.afterClosed().subscribe((resultData) => {

      if (resultData) {
        let tLegends = resultData;
        //debugger;

        if (tLegends[0].IsApplied == 1)//susheel
          this.appliedLegendThreshold.push(tLegends[0].ConditionValue.replace(/::true/gi, '').replace(/::false/gi, ''));//add or re-add applied new threshold

        if (pinType == "Threshold Type") {
          let allTRs = ";" + this.thresholdLegendsCount;//document.getElementById("hidMapLegendsApplyOrNot").value;//All applied TRs
          let entireThresholds = ";" + this.thresholdLegends; // document.getElementById("hidMapLegendsThresholds").value;

          if (allTRs.indexOf(';' + currPinRsltIndx + ';') != -1) {//leg each pin index
            allTRs = allTRs.replace(';' + currPinRsltIndx + ';', ';');//remove existing pin index applied

            var subVal = entireThresholds.substring(entireThresholds.indexOf(';' + currPinRsltIndx + '@'), entireThresholds.indexOf('@' + currPinRsltIndx + ';') + 3); //entireThresholds.substring(entireThresholds.indexOf(';' + document.getElementById("hidMapLegends").value + '@'), entireThresholds.indexOf('@' + document.getElementById("hidMapLegends").value + ';') + 3);
            entireThresholds = entireThresholds.replace(subVal, ';');//empty existing pin index's threshold val applied
          }
          else//Current applied tr newly
          {
            allTRs += currPinRsltIndx + ';'; //add pin index
            entireThresholds += currPinRsltIndx + "@"; //Indicating respective pin Index

            for (let i = 0; i < tLegends.length; i++) {
              //console.log(tLegends[i].OperatorDropDown)
              // $('#trMapLeg' + document.getElementById("hidMapLegends").value).find("input").each(function () {
              var x = "";
              //if (this.id.indexOf('DevID') != -1) //Device ID ^ as start
              //  x = this.value + "$";
              //else if (this.id.indexOf('txtMapLeg') != -1)//Operator ~ threshold ~ AND/OR of each parameter
              //  x = (document.getElementById(this.id.replace('txt', 'ddl')) != null ? document.getElementById(this.id.replace('txt', 'ddl')).selectedIndex : "0") + "-" + this.value + "^" + (document.getElementById(this.id.replace('txtMapLeg', 'ddlAndOrMapLeg')) != null ? document.getElementById(this.id.replace('txtMapLeg', 'ddlAndOrMapLeg')).value : "AND") + ",";
              if (tLegends[i].IsVquadData == 1) {
                x = tLegends[i].Text + "$";
              }
              else {
                x = tLegends[i].newOperatorIndex + "-" + tLegends[i].Text + "^" + (tLegends[i].AndORDropDown != null ? tLegends[i].AndORDropDown : "AND") + ",";
              }

              entireThresholds += x;//single or multi thresholds set here
              // });
            }
            entireThresholds += "@" + currPinRsltIndx + ";"; //closing with respective pin Index

          }
          ///document.getElementById("hidMapLegendsThresholds").value = entireThresholds.substring(1, entireThresholds.length);//Remove first and last ;'s
          ///document.getElementById("hidMapLegendsApplyOrNot").value = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          this.thresholdLegends = entireThresholds.substring(1, entireThresholds.length);//Remove first and last ;'s
          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(this.thresholdLegends)
          //console.log(this.thresholdLegendsCount)
        }
        else if (pinType == "VQuad Call ID Type") {
          let allTRs = ";" + this.thresholdLegendsCount;
          if (allTRs.indexOf(';' + currPinRsltIndx + ';') == -1)
            allTRs += currPinRsltIndx + ';'; //add rslt index

          let entireCallIDs = ";" + this.callIDLegends;

          entireCallIDs += tLegends[0].currCritListValue;

          //entireCallIDs += "@" + currPinRsltIndx + ";";
          this.callIDLegends = entireCallIDs;

          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(entireCallIDs)
          //console.log(this.thresholdLegendsCount)
        }
        else if (pinType == "VQuad Device ID Type") {
          let allTRs = ";" + this.thresholdLegendsCount;
          if (allTRs.indexOf(';' + currPinRsltIndx + ';') == -1)
            allTRs += currPinRsltIndx + ';'; //add rslt index

          let entireDevIDs = ";" + this.devIDLegends;

          entireDevIDs += tLegends[0].currCritListValue;

          //entireDevIDs += "@" + currPinRsltIndx + ";";
          this.devIDLegends = entireDevIDs;

          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(entireDevIDs)
          //console.log(this.thresholdLegendsCount)
        }
        else if (pinType == "Call Control Event Type") {
          let allTRs = ";" + this.thresholdLegendsCount;
          if (allTRs.indexOf(';' + currPinRsltIndx + ';') == -1)
            allTRs += currPinRsltIndx + ';'; //add rslt index

          let entireCCEs = ";" + this.callEventsLegends;

          entireCCEs += tLegends[0].currCritListValue;

          //entireCCEs += "@" + currPinRsltIndx + ";";
          this.callEventsLegends = entireCCEs;

          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(entireDevIDs)
          //console.log(this.thresholdLegendsCount)
        }

        this.GetMapConfigByID(this.mapConfigID, 1);

      } else {
        //this.pinColor = 'Nothing...';
      }
    });



    //this.showPopupLegend = true;
  }

  CloseMapLegendWin() {
    // this.showPopupLegend = false;
  }

  /////////////////////////// end Popup Section bluetooth and status display

  //////////////////   left panel Checkbox list

  SpiralClicked() {
    //alert();
  }


  DisplayResultList = [
    {
      Name: "Results",
      Value: "0",
      Checked: true
    },
    {
      Name: "Failures",
      Value: "1",
      Checked: true
    },
    {
      Name: "VQuad Nodes",
      Value: "2",
      Checked: true
    },
    {
      Name: "Mobile Devices",
      Value: "3",
      Checked: true
    }
  ];

  AnalysisList = [
    //{
    //  Name: "Check/UnCheck All",
    //  Value: "1",
    //  Checked: true
    //},
    {
      Name: "Failures",
      Value: "2",
      Checked: true
    },
    {
      Name: "Call Events",
      Value: "3",
      Checked: true
    },
    {
      Name: "PESQ",
      Value: "4",
      Checked: true
    },
    {
      Name: "POLQA",
      Value: "5",
      Checked: true
    },
    {
      Name: "RTD",
      Value: "6",
      Checked: true
    },
    {
      Name: "OWD",
      Value: "7",
      Checked: true
    },
    {
      Name: "PDD",
      Value: "8",
      Checked: true
    },
    {
      Name: "SNR",
      Value: "9",
      Checked: true
    },
    {
      Name: "EModule",
      Value: "10",
      Checked: true
    },
    {
      Name: "EMU",
      Value: "11",
      Checked: true
    },
    {
      Name: "FAX",
      Value: "12",
      Checked: true
    },
    {
      Name: "VAC",
      Value: "13",
      Checked: true
    },
  ];

  NetTestList = [
    //{
    //  Name: "Check/UnCheck All",
    //  Value: "0",
    //  Checked: true
    //},
    {
      Name: "Failures",
      Value: "1",
      Checked: true
    },
    {
      Name: "Connection Drop",
      Value: "2",
      Checked: true
    },
    {
      Name: "TCP",
      Value: "3",
      Checked: true
    },
    {
      Name: "UDP",
      Value: "4",
      Checked: true
    },
    {
      Name: "VOIP",
      Value: "5",
      Checked: true
    },
    {
      Name: "ROUTE",
      Value: "6",
      Checked: true
    },
    {
      Name: "HTTP",
      Value: "7",
      Checked: true
    },
    {
      Name: "FTP",
      Value: "8",
      Checked: true
    },
    {
      Name: "DNS",
      Value: "9",
      Checked: true
    },
    {
      Name: "SMS",
      Value: "10",
      Checked: true
    },
    {
      Name: "EMAIL",
      Value: "11",
      Checked: true
    }
  ];

  MobileInfoList = [
    //{
    //  Name: "Check/UnChecl All",
    //  Value: "0",
    //  Checked: true
    //},
    {
      Name: "Failures",
      Value: "1",
      Checked: true
    },
    {
      Name: "PHONEINFO",
      Value: "2",
      Checked: true
    },
    {
      Name: "SIM",
      Value: "3",
      Checked: true
    },
    {
      Name: "UE",
      Value: "4",
      Checked: true
    }
  ];

  ErrorEventList = [
    //{
    //  Name: "Check/UnCheck All",
    //  Value: "0",
    //  Checked: true
    //},
    {
      Name: "Call Events",
      Value: "1",
      Checked: true
    },
    {
      Name: "RTD",
      Value: "2",
      Checked: true
    },
    {
      Name: "OWD",
      Value: "3",
      Checked: true
    },
    {
      Name: "PDD",
      Value: "4",
      Checked: true
    },
    {
      Name: "SNR",
      Value: "5",
      Checked: true
    },
    {
      Name: "FAX",
      Value: "6",
      Checked: true
    }
  ];

  TypeList = [
    {
      Name: "Threshold Settings",
      Value: "0",
      Checked: false
    },
    {
      Name: "VQuad Call ID",
      Value: "1",
      Checked: false
    },
    {
      Name: "VQuad Devcie ID",
      Value: "2",
      Checked: false
    },
    {
      Name: "Call Events",
      Value: "3",
      Checked: false
    }
  ];

  ResultList = [
    {
      Name: "VQT PESQ",
      Value: "VQTDATA|0|",
      Checked: false
    },
    {
      Name: "VQT POLQA",
      Value: "VQTPOLQA|1|",
      Checked: false
    },
    {
      Name: "VQuad Call Events",
      Value: "VQUADDATA|2|",
      Checked: false
    },
    {
      Name: "Audio and Delay Analysis",
      Value: "VQUADDATA|3|",
      Checked: false
    },
    {
      Name: "TCP",
      Value: "TCPDATA|4|",
      Checked: false
    },
    {
      Name: "UDP",
      Value: "UDPDATA|5|",
      Checked: false
    },
    {
      Name: "VOIP",
      Value: "VOIPDATA|6|",
      Checked: false
    },
    {
      Name: "ROUTE",
      Value: "ROUTEDATA|7|",
      Checked: false
    },
    {
      Name: "HTTP",
      Value: "HTTPDATA|8|",
      Checked: false
    },
    {
      Name: "FTP",
      Value: "FTPDATA|9|",
      Checked: false
    },
    {
      Name: "DNS",
      Value: "DNSDATA|10|",
      Checked: false
    },
    {
      Name: "SMS",
      Value: "SMSDATA|11|",
      Checked: false
    },
    {
      Name: "EMAIL",
      Value: "EMAILDATA|12|",
      Checked: false
    },
    {
      Name: "Phone Info",
      Value: "GENERALINFO|13|",
      Checked: false
    },
    {
      Name: "SIM",
      Value: "SIMINFO|14|",
      Checked: false
    },
    {
      Name: "UE",
      Value: "UEINFO|15|",
      Checked: false
    },
    {
      Name: "EMU",
      Value: "EMUDATA|16|",
      Checked: false
    },
    {
      Name: "FAX",
      Value: "FAXDATA|17|",
      Checked: false
    },
    {
      Name: "EModule",
      Value: "EModule|18|",
      Checked: false
    },
    {
      Name: "Connection Drop",
      Value: "CONNDROPDATA|19|",
      Checked: false
    },
    {
      Name: "VAC",
      Value: "VACDATA|20|",
      Checked: false
    }
  ];

  //////////////////   left panel Checkbox list

  ////////////////////////////////////////////////////////////// SERVICES /////////////////////////////////////////////////////

  GetMapConfigData_Service() {
    //debugger
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.preDefinedConfigParam, options);

  }

  GetMapConfigDataByID_Service() {
    //debugger
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.mapDisplayOptions, options);

  }

  GetMapDispayOptions_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.mapDisplayOptions, options);

  }

  SetTimestampSearch(tsSearch) {
    switch (tsSearch) {
      case 0:
        return "CALL_TIMESTAMP";
      case 1:
        return "VQUAD_TIMESTAMP";
      case 2:
        return "VQT_Timestamp";
      case 3:
        return "DCOSS_TIMESTAMP";
    }

  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
    //this.setRsltType();
    //debugger;
    //////// Common filter dates 
    ////let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";  
    //this.commonFilterService.TSBetween.subscribe(res => this.commonFilterDates = res);//latest dates selected is set here from service
    ////Added to set proper dates here based on range selection
    //this.commonFilterService.TSRangeFilter.subscribe(res => {
    //  if (res.RangeType !== "custom")
    //  { this.commonFilterDates = lastDateFunc(res.RangeType) }
    //});//sets start and end dates to latest timestamps based on range type selection - IMP

    //this.commonFilterService.setDatesProperties(this.commonFilterDates);

    this.commonFilterService.usePredefinedConfig.subscribe(res => this.usePredefinedConfig = res);
    this.GetPredefinedConfig(this.selMapConfig);
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

}

// just an interface for type safety.
class marker {
  lat: string;
  lng: string;
  label?: string;
  draggable: boolean;
  iconurl: string;
  widthImg: number;
  heightImg: number;
  resultType: string;
  popUpRsltType: string;
  itemID: string;
}
class markerDisplay {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  iconurl: string;
  widthImg: number;
  heightImg: number;
  resultType: string;
  popUpRsltType: string;
  itemID: string;
}

class PredefinedConfig {
  getINISettings: string = "";
  strStartDate: string = "";
  strEndDate: string = "";
  strLastRecord: string = "";
  TimeStamp_Type: string = "";
  FilterOnOff: number = 1;
  drawRoute: number = 0;

  thresholdLegends: string = "";
  thresholdLegendsCount: string = "";
  callIDLegends: string = "";//susheel
  devIDLegends: string = "";
  callEventsLegends: string = "";

  gMapConfigID: number = 0;
  MainFilterID: number = 0;
  limitPinCount: boolean = true;

  generalFilter = [];
}
